/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Format_AnyInputs */



/**
* | output |
* | --- |
* | "Any format" |
*
* @param {Tfield_Format_AnyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_format_any = /** @type {((inputs?: Tfield_Format_AnyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Format_AnyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout format")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cualquier formato")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Qualquer formato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Qualsiasi formato")
	return /** @type {LocalizedString} */ ("Any format")
});